import { slideDown, slideUp } from './startup/slide';
import { getCookie, setCookie } from './startup/cookies-helper';
import { getRemainingTime } from './utils/remaining-time';

declare global {
  interface Window {
    en: boolean;
  }
}

const en = window.en;

const header = document.getElementById('header');
const bannerTemplates = document.querySelectorAll('#header template') as NodeListOf<HTMLTemplateElement>;
const showLanguageHint = getCookie('language-hint-closed') !== 'true' && !en && !navigator.language.startsWith('de');
let onAppCall: string | null = null;
try {
  onAppCall = window.sessionStorage.getItem('onAppCall');
} catch (e) {
  // sessionStorage blocked in strict privacy mode
}

// r2F Banner
if (header && bannerTemplates.length && !showLanguageHint && getCookie('top-banner-closed') === 'false' && !onAppCall) {
  //Fill counter till eoy in Autumn Banner only
  let activeBannerTemplate: null | HTMLTemplateElement = null;
  let endInteger: null | number = null;
  let todayInteger: null | number = null;

  bannerTemplates.forEach(bannerTemplate => {
    if (activeBannerTemplate) {
      bannerTemplate.remove();
      return;
    }
    const endDate = bannerTemplate.dataset.endDate;

    if (endDate) {
      const todayDate = new Date();
      const [year, month, day] = endDate.split('-').map(Number);
      const end = new Date(year, month - 1, day);
      if (0 > end.getTime() - todayDate.getTime()) {
        return;
      }
      endInteger = end.getTime();
      todayInteger = todayDate.getTime();
    }

    activeBannerTemplate = bannerTemplate;
    bannerTemplate.remove();
  });

  if (activeBannerTemplate) {
    const template = activeBannerTemplate as HTMLTemplateElement;
    const bannerClone = template.content.cloneNode(true) as DocumentFragment;
    const bannerCustomStylesTemplate = bannerClone.querySelector('template');

    header.insertBefore(bannerClone, header.firstChild);
    if (bannerCustomStylesTemplate) {
      document.head.appendChild(bannerCustomStylesTemplate.content.cloneNode(true));
    }

    const banner = header.querySelector('.top-banner-wrapper') as HTMLElement;
    header.classList.add('banner-hidden');
    window.dispatchEvent(new Event('bannerInitialized'));

    if (banner) {
      const texts = banner.querySelectorAll('.banner-text');

      const countdownCase = template.dataset.countdownCase;
      if (endInteger && todayInteger && countdownCase && texts) {
        const { countdownText, lastDay } = getRemainingTime(endInteger, todayInteger, countdownCase);
        if (!lastDay && countdownText) {
          const remaining = banner.querySelector('.remaining-counter');
          if (remaining) {
            remaining.innerHTML = countdownText;
          }
        } else if (texts.length > 1) {
          texts.forEach(text => {
            text.classList.toggle('is-hidden', !text.classList.contains('is-hidden'));
          });
        }
      }
      // Add close click
      const closeButton = banner.querySelector('.banner-close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          setCookie('top-banner-closed', 'true', 7);
          header?.classList.remove('banner-shown');

          header.classList.add('banner-hidden');
          window.dispatchEvent(new Event('headerSizeChanged'));
          setTimeout(() => {
            header.classList.remove('keep-banner-hidden', 'force-hide-banner');
            banner.style.setProperty('visibility', 'hidden');
          }, 300);
        });
      }

      function slideDownBanner() {
        header?.classList.add('banner-shown');
        header?.classList.remove('banner-hidden');
        banner.style.removeProperty('visibility');
        window.dispatchEvent(new Event('headerSizeChanged'));
      }

      const totalScrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const showBannerOnScroll = totalScrollHeight > (window.matchMedia('(max-width: 767px)').matches ? 2 : 1.5) * window.innerHeight;

      if (showBannerOnScroll) {
        const scrollingGoal = totalScrollHeight * 0.1;
        let scrollTimeOut: ReturnType<typeof setTimeout>;
        const startingScrollPosition = window.scrollY;

        window.addEventListener('scroll', checkShowBanner);

        function checkShowBanner() {
          clearTimeout(scrollTimeOut);
          scrollTimeOut = setTimeout(() => {
            if (
              startingScrollPosition !== window.scrollY &&
              (startingScrollPosition + 300 < window.scrollY || startingScrollPosition - 300 > window.scrollY) &&
              scrollingGoal &&
              window.scrollY > (header?.offsetHeight || 0) * 5
            ) {
              slideDownBanner();
              window.removeEventListener('scroll', checkShowBanner);
            }
          }, 750);
        }
      } else {
        const handleOtherInteraction = (event: Event) => {
          const target = event.target as HTMLElement;
          if (target.tagName === 'A' && target.getAttribute('href')) {
            return;
          }
          setTimeout(() => {
            slideDownBanner();
            document.removeEventListener('click', handleOtherInteraction);
            document.removeEventListener('keydown', handleOtherInteraction);
          }, 1000);
        };
        document.addEventListener('click', handleOtherInteraction);
        document.addEventListener('keydown', handleOtherInteraction);
      }
    }
  } else {
    window.dispatchEvent(new Event('bannerInitialized'));
  }
} else {
  window.dispatchEvent(new Event('bannerInitialized'));
}
